import { clsx } from 'clsx'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import s from './styles.module.scss'

interface ISnackBarProps {
  time?: number
  targetSelector: string
  isOpen: boolean
  children: React.ReactNode
  onClose?: () => void
}

const PortalSnackbar = ({
  targetSelector,
  isOpen,
  children,
  onClose,
  time = 5000,
}: ISnackBarProps) => {
  const [targetElement, setTargetElement] = useState<Element | null>(null)

  useEffect(() => {
    const element = document.querySelector(targetSelector)
    setTargetElement(element)
  }, [targetSelector])

  useEffect(() => {
    setTimeout(() => {
      onClose && onClose()
    }, time)
  }, [onClose, time])

  if (!isOpen || !targetElement) {
    return null
  }

  return ReactDOM.createPortal(
    <div className={clsx(s.container)}>{children}</div>,
    targetElement,
  )
}

export default PortalSnackbar
